// extracted by mini-css-extract-plugin
export default {"imgdiv":"_657b84d80e _1e3df1a6f9","img":"_49bf5016d0 _2d6f57689d"};